// @flow

import AWS from "aws-sdk/global"; // AWS config only
import S3 from "aws-sdk/clients/s3";
import "aws-sdk/lib/credentials/cognito_identity_credentials";
import {
  CognitoUserPool,
  AuthenticationDetails,
  CognitoUser
} from "amazon-cognito-identity-js";
import { config, validConfig } from "../config";
import sigV4Client from "./sig_v4_client";
import { promisify } from "./utils";

let user;

export async function invokeApig({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  body
}) {
  if (!(await authUser())) {
    throw new Error("User is not logged in");
  }

  const signedRequest = sigV4Client
    .newClient({
      accessKey: AWS.config.credentials.accessKeyId,
      secretKey: AWS.config.credentials.secretAccessKey,
      sessionToken: AWS.config.credentials.sessionToken,
      region: config().apiGateway.REGION,
      endpoint: config().apiGateway.URL
    })
    .signRequest({
      method,
      path,
      headers,
      queryParams,
      body
    });

  body = body ? JSON.stringify(body) : body;
  headers = signedRequest.headers;

  const results = await fetch(signedRequest.url, {
    method,
    headers,
    body
  });

  if (results.status !== 200) {
    throw new Error(await results.text());
  }

  return results.json();
}

export async function authUser() {
  if (
    AWS.config.credentials &&
    Date.now() < AWS.config.credentials.expireTime - 60000
  ) {
    return true;
  }

  const site = localStorage.getItem('SITE_NAME')
  if (!site || !validConfig(site)) {
    return false
  }

  const currentUser = getCurrentUser();

  if (currentUser === null) {
    return false;
  }

  const userToken = await getUserToken(currentUser);

  await getAwsCredentials(userToken);

  return true;
}

export function signOutUser() {
  const currentUser = getCurrentUser();

  if (currentUser !== null) {
    currentUser.signOut();
  }
}

function getUserToken(currentUser) {
  return new Promise((resolve, reject) => {
    currentUser.getSession((err, session) => {
      if (err) {
        reject(err);
        return;
      }
      resolve(session.getIdToken().getJwtToken());
    });
  });
}

function getCurrentUser() {
  const userPool = new CognitoUserPool({
    UserPoolId: config().cognito.USER_POOL_ID,
    ClientId: config().cognito.APP_CLIENT_ID
  });
  return userPool.getCurrentUser();
}

function getAwsCredentials(userToken) {
  const authenticator = `cognito-idp.${config().cognito.REGION}.amazonaws.com/${config().cognito.USER_POOL_ID}`;

  AWS.config.update({ region: config().cognito.REGION });

  AWS.config.credentials = new AWS.CognitoIdentityCredentials({
    IdentityPoolId: config().cognito.IDENTITY_POOL_ID,
    Logins: {
      [authenticator]: userToken
    }
  });

  return AWS.config.credentials.getPromise();
}

// function getAwsCredentials(userToken, force) {
//   if (!force && AWS.config.credentials && Date.now() < AWS.config.credentials.expireTime - 60000) {
//     return Promise.resolve(AWS.config.credentials);
//   }

//   const authenticator = `cognito-idp.${config().cognito.REGION}.amazonaws.com/${config().cognito.USER_POOL_ID}`;

//   AWS.config.update({ region: config().cognito.REGION });
//   AWS.config.credentials = new AWS.CognitoIdentityCredentials({
//     IdentityPoolId: config().cognito.IDENTITY_POOL_ID,
//     ...(!userToken ? {} : {
//       Logins: {
//         [authenticator]: userToken
//       }
//     })
//   });

//   return AWS.config.credentials
//     .getPromise()
//     .then(() => AWS.config.credentials);
// }

// function getUserToken(currentUser) {
//   return new Promise((resolve, reject) => {
//     currentUser.getSession((err, session) => {
//       if (err) {
//         reject(err);
//         return;
//       }
//       resolve(session.getIdToken().getJwtToken());
//     });
//   });
// }

// function getCurrentUser() {
//   const userPool = new CognitoUserPool({
//     UserPoolId: config().cognito.USER_POOL_ID,
//     ClientId: config().cognito.APP_CLIENT_ID
//   });
//   return userPool.getCurrentUser();
// }

export function getAccessToken() {
  return new Promise((resolve, reject) => {
    getCurrentUser().getSession((err, session) => {
      if (err) {
        reject(err);
        return;
      }
      resolve(session.getAccessToken().getJwtToken());
    });
  });
}

// export function authUser() {
//   const currentUser = getCurrentUser();

//   if (currentUser === null) {
//     console.log('authUser', false);
//     return Promise.resolve(false);
//   }

//   return getUserToken(currentUser)
//     .then(getAwsCredentials)
//     .then(() => {
//       user = currentUser;
//       console.log('authUser new ', true);
//       return true;
//     });
// }

// export function isAdminUser() {
//   const currentUser = getCurrentUser();
//   return currentUser && currentUser.username === 'admin';
// }

// export function getCurrentUserId(callback) {
//   if (!user) callback(null);
//   user.getUserAttributes((err, result) => {
//     if (err) {
//       callback(null);
//     } else {
//       let sub = result.find(x => x.getName() === 'sub');
//       if (sub && sub.getValue) sub = sub.getValue();
//       callback(sub);
//     }
//   });
// }

// export function getCurrentUserAttributes() {
//   return getAwsCredentials()
//     .then(() => new Promise((resolve, reject) => {
//       const user = getCurrentUser();

//       user.getSession((err, result) => {
//         if (err) return reject(err);

//         user.getUserAttributes((err, result) => {
//           if (err) return reject(err);

//           const attrs = result.reduce((prev, cur) => {
//             prev[cur.Name] = cur.Value;
//             return prev;
//           }, {});

//           resolve(attrs);
//         });
//       });
//     }));
// }

// export function getCurrentUserName() {
//   return getCurrentUser().username;
// }

export function signOut() {
  const currentUser = getCurrentUser();

  if (currentUser !== null) {
    currentUser.signOut();
  }

  if (AWS.config.credentials) {
    AWS.config.credentials.clearCachedId();
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({});
  }
}

export function forgotPassword(phone) {
  const userPool = new CognitoUserPool({
    UserPoolId: config().cognito.USER_POOL_ID,
    ClientId: config().cognito.APP_CLIENT_ID
  });
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: phone, Pool: userPool });
    let verificationCode = "529718";
    let newPassword = "Password1!";

    user.confirmPassword(verificationCode, newPassword, {
      onFailure(err) {
        reject(err);
      },
      onSuccess() {
        resolve();
      }
    });
  });
}

export function confirmPassword(username, verificationCode, newPassword) { }

export function signIn(phone, password) {
  const userPool = new CognitoUserPool({
    UserPoolId: config().cognito.USER_POOL_ID,
    ClientId: config().cognito.APP_CLIENT_ID
  });
  const user = new CognitoUser({ Username: phone, Pool: userPool });
  const authenticationData = { Username: phone, Password: password };
  const authenticationDetails = new AuthenticationDetails(authenticationData);

  return new Promise((resolve, reject) => {
    user.authenticateUser(authenticationDetails, {
      onSuccess: result => {
        const token = result.getIdToken().getJwtToken();
        resolve(getAwsCredentials(token, true));
      },
      onFailure: e => {
        reject(e);
      },
      newPasswordRequired: (userAttributes, requiredAttributes) => {
        // console.log(requiredAttributes);
        user.completeNewPasswordChallenge("Password1!", {}, this);
      }
    });
  });
}

export function login(email, password) {
  const userPool = new CognitoUserPool({
    UserPoolId: config().cognito.USER_POOL_ID,
    ClientId: config().cognito.APP_CLIENT_ID
  });
  const user = new CognitoUser({ Username: email, Pool: userPool });
  const authenticationData = { Username: email, Password: password };
  const authenticationDetails = new AuthenticationDetails(authenticationData);

  return new Promise((resolve, reject) =>
    user.authenticateUser(authenticationDetails, {
      onSuccess: result => resolve(),
      onFailure: err => reject(err),
      newPasswordRequired: (userAttributes, requiredAttributes) => {
        // console.log(requiredAttributes);
        user.completeNewPasswordChallenge("Password1!", {}, this);
      }
    })
  );
}

export function confirmUser(phone, code) {
  const userPool = new CognitoUserPool({
    UserPoolId: config().cognito.USER_POOL_ID,
    ClientId: config().cognito.APP_CLIENT_ID
  });
  const userData = {
    Username: phone,
    Pool: userPool
  };
  const cognitoUser = new CognitoUser(userData);
  const confirmRegistration = promisify(
    cognitoUser.confirmRegistration,
    cognitoUser
  );

  return confirmRegistration(code, true);
}

export function invokeApi({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  body
}) {
  return fetch(config().apiGateway.URL + path, {
    method,
    headers,
    body
  }).then(results => {
    if (results.status !== 200) {
      return results.json().then(data => {
        throw new Error(data.msg);
      });
    }

    return results.json();
  });
}

export function invokeLoggedInApi({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  body
}) {
  // if (!await authUser()) {
  //   throw new Error('User is not logged in');
  // }

  return authUser()
    .then(isLogined => {
      if (!isLogined) {
        throw new Error("not logged in yet");
      }

      return Promise.all([getAwsCredentials(), getAccessToken()]);
    })
    .then(([credentials, accessToken]) => {
      const signedRequest = sigV4Client
        .newClient({
          accessKey: credentials.accessKeyId,
          secretKey: credentials.secretAccessKey,
          sessionToken: credentials.sessionToken,
          region: config().apiGateway.REGION,
          endpoint: config().apiGateway.URL
        })
        .signRequest({
          method,
          path,
          headers,
          queryParams,
          body
        });

      // body = body && JSON.stringify(body);
      headers = signedRequest.headers;

      return fetch(signedRequest.url, {
        method,
        body,
        headers
      }).then(results => {
        if (results.status !== 200) {
          return results.json().then(data => {
            throw new Error(data.msg);
          });
        }

        return results.json();
      });
    });
}

export function s3Upload(file, name, ext, root) {
  return authUser().then(() => {
    const s3 = new S3({
      params: {
        Bucket: root ? config().s3.BUCKET_ROOT : config().s3.BUCKET
      }
    });
    const filename = name || "sample";

    return s3
      .upload({
        Key: filename,
        Body: file,
        ContentType: ext,
        ACL: "public-read",
        CacheControl: "max-age=2592000"
      })
      .promise()
      .then(
        data => data,
        e => {
          console.error(e.stack);
        }
      );
  });
}

export function s3Move(name, copySource) {
  return s3Copy(name, copySource).then(() => s3Delete(copySource));
}

export function s3Copy(name, copySource) {
  return authUser().then(() => {
    const s3 = new S3({
      params: {
        Bucket: config().s3.BUCKET
      }
    });
    const filename = name || "sample";

    return s3
      .copyObject({
        Key: filename,
        CopySource: `${config().s3.BUCKET}/${copySource}`,
        ACL: "public-read"
      })
      .promise()
      .then(
        data => data,
        e => {
          console.error(e.stack);
        }
      );
  });
}

export function s3Delete(filename) {
  return authUser().then(() => {
    const s3 = new S3({
      params: {
        Bucket: config().s3.BUCKET
      }
    });

    return s3
      .deleteObject({
        Key: filename
      })
      .promise()
      .then(
        data => data,
        e => {
          console.error(e.stack);
        }
      );
  });
}
